import React from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { StyledSubHeader } from 'src/components/TableViews/ManageColumnsDrawer/styled-components'

export const CANDIDATE_SECTION_KEY_PREFIX = 'candidate-section:'

type Props = {
  id: string
  label: string
}
const CandidateSectionHeader = ({ id, label }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })
  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        pointerEvents: 'none',
      }}
    >
      <StyledSubHeader {...attributes} {...listeners}>
        {label}
      </StyledSubHeader>
    </div>
  )
}

export default React.memo(CandidateSectionHeader)
